import { render, staticRenderFns } from "./AssetDetailOverview.vue?vue&type=template&id=779424a4&scoped=true&"
import script from "./AssetDetailOverview.vue?vue&type=script&lang=js&"
export * from "./AssetDetailOverview.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailOverview.vue?vue&type=style&index=0&id=779424a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779424a4",
  null
  
)

/* custom blocks */
import block0 from "./AssetDetailOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports